import Page, { getStaticPageProps } from 'pages/[...page]';
import { getStaticPropsData } from '../../lib/getStaticProps';

export default Page;

export const getStaticProps = getStaticPageProps({
  lang: 'en-gb',
  prefix: '/en',
});

export async function getStaticPaths() {
  const { pages } = await getStaticPropsData({ params: { lang: 'en-gb' } });
  const paths = pages
    .map((page: any) => page.url)
    .filter((x: any) => {
      if (x?.indexOf('interest-rates-and-fees') > -1) {
        return false;
      }
      /* if (process.env.ONLY_PAGE) {
        const test = new RegExp(process.env.ONLY_PAGE);
        return !!x?.url?.match(test);
      }*/
      return true;
    });
  return {
    paths: paths,
    fallback: 'blocking',
  };
}
